export var IDENTIFIER_SNACKBAR_LIST = 'snackbar-list';
export var IDENTIFIER_SNACKBAR_ITEM = 'snackbar-item';
